module.exports = __webpack_public_path__ + "static/media/design_03@2x.2a1a0087.png";